import { createContext, useContext, useState, useCallback } from 'react';
import { tokenStore, decodeToken, isTokenExpired } from '../utils/token.js';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // Restore session from sessionStorage on page refresh
  const [user, setUser] = useState(() => {
    const stored = tokenStore.get();
    return stored ? decodeToken(stored) : null;
  });

  const login = useCallback(async (token) => {
    if (!token || isTokenExpired(token)) return false;
    tokenStore.set(token);
    setUser(decodeToken(token));
    return true;
  }, []);

  const logout = useCallback(() => {
    tokenStore.clear();
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
}

export const ROLES = { user: 0, admin: 1, owner: 2 };

export function hasRole(user, required) {
  if (!user) return false;
  return (ROLES[user.role] ?? -1) >= (ROLES[required] ?? 0);
}
